import React, { FC, useRef } from 'react';
import Lozenge from '@atlaskit/lozenge';
import pluralize from 'pluralize';
import { SloQualityResultDTO } from '@atlassiansox/phobos-client-ts';

import { flexStart, spaceGapMinimum } from '@/styles';

import QualityScoreHelper from './quality-score-helper';
import SloQualityLozenge from './slo-quality-lozenge';
import { testIds } from './constants';
import { getQualityIssueCount, getQualityWarningCount, isQualityAvailable } from './utils';

type QualityScoreIndicatorProps = {
  quality?: SloQualityResultDTO;
};

const QualityScoreIndicator: FC<QualityScoreIndicatorProps> = ({ quality }) => {
  const refSummary = useRef<HTMLDivElement>(null);

  if (!quality || !isQualityAvailable(quality)) {
    return null;
  }

  const issueCount = getQualityIssueCount(quality);
  const warningCount = getQualityWarningCount(quality);

  return (
    <div
      css={[flexStart, spaceGapMinimum]}
      data-testid={testIds.qualityScoreIndicator}
      onClick={event => event.stopPropagation()}
    >
      <SloQualityLozenge appearance={quality.qualityScore === 10 ? 'success' : 'removed'}>
        {quality.qualityScore}
      </SloQualityLozenge>
      {issueCount > 0 && (
        <Lozenge appearance="moved">
          {issueCount} {pluralize('issue', issueCount)}
        </Lozenge>
      )}
      {warningCount > 0 && (
        <Lozenge appearance="moved">
          {warningCount} {pluralize('warning', warningCount)}
        </Lozenge>
      )}
      <QualityScoreHelper quality={quality} refSummary={refSummary} />
      <span ref={refSummary} />
    </div>
  );
};

export default QualityScoreIndicator;
